module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$is('driver-info')) ? _c('div', {
    staticClass: "field-driver-info"
  }, [_c('driver-fields', {
    attrs: {
      "fieldName": 'driver-status',
      "item": _vm.item
    }
  }), _c('driver-fields', {
    attrs: {
      "fieldName": 'driver-id',
      "item": _vm.item
    }
  }), _c('driver-fields', {
    attrs: {
      "fieldName": 'driver-fullname',
      "item": _vm.item
    }
  })], 1) : (_vm.$is('driver-info-no-status')) ? _c('div', {
    staticClass: "field-driver-info-no-status"
  }, [_c('driver-fields', {
    attrs: {
      "fieldName": 'driver-id',
      "item": _vm.item
    }
  }), _c('driver-fields', {
    attrs: {
      "fieldName": 'driver-fullname',
      "item": _vm.item
    }
  })], 1) : (_vm.$is('driver-status')) ? _c('div', {
    staticClass: "field-driver-status"
  }, [_c('status', {
    staticClass: "float-left",
    attrs: {
      "status": _vm.item.status
    }
  }), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])], 1) : (_vm.$is('driver-id')) ? _c('div', {
    staticClass: "field-driver-id"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("DR" + _vm._s(_vm.item.id))])], 1) : (_vm.$is('driver-uid')) ? _c('div', {
    staticClass: "field-driver-uid"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.uid))])]) : (_vm.$is('client-info')) ? _c('div', {
    staticClass: "field-client-info"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'client',
        params: {
          id: _vm.item.client_id
        }
      }
    }
  }, [_vm._v("CL" + _vm._s(_vm.item.client_id))])], 1), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.client_name))])]) : (_vm.$is('city')) ? _c('div', {
    staticClass: "field-city"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.address.city))])]) : (_vm.$is('created')) ? _c('div', {
    staticClass: "field-created"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.created, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('updated')) ? _c('div', {
    staticClass: "field-updated"
  }, [_c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.$dateFormat(_vm.item.updated, _vm.$toMomentFormat(_vm.configuration.locale.locale_datetime_format.value))))])]) : (_vm.$is('phone-and-email')) ? _c('div', {
    staticClass: "field-phone-and-email"
  }, [_c('div', {
    staticClass: "field-phone"
  }, [_vm._v(_vm._s(_vm.item.phone))]), _c('div', {
    staticClass: "field-email"
  }, [_vm._v(_vm._s(_vm.item.email))])]) : (_vm.$is('driver-fullname')) ? _c('div', {
    staticClass: "driver-fullname",
    attrs: {
      "fieldName": 'driver-name'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])], 1) : (_vm.$is('driver-name')) ? _c('div', {
    staticClass: "driver-name",
    attrs: {
      "fieldName": 'driver-name'
    }
  }, [_vm._v(_vm._s(_vm.item.name))]) : (_vm.$is('driver-surname')) ? _c('div', {
    staticClass: "driver-surname",
    attrs: {
      "fieldName": 'driver-surname'
    }
  }, [_vm._v(_vm._s(_vm.item.surname))]) : (_vm.$is('driver-gender')) ? _c('div', {
    staticClass: "driver-gender",
    attrs: {
      "fieldName": 'driver-gender'
    }
  }, [_vm._v(_vm._s(_vm.item.gender))]) : (_vm.$is('driver-country')) ? _c('div', {
    staticClass: "driver-country",
    attrs: {
      "fieldName": 'driver-country'
    }
  }, [_vm._v(_vm._s(_vm.item.address.country))]) : (_vm.$is('driver-id')) ? _c('div', {
    staticClass: "driver-id",
    attrs: {
      "type": 'driver-id'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'driver',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.item.name) + " " + _vm._s(_vm.item.surname))])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52123692!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/entity-fields/DriverFields.vue
// module id = 2494
// module chunks = 1